import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getAssetId = async (name: string) => {
  const { data, error } = await supabase
    .from('assets')
    .select('id')
    .eq('ticker', name)
    .eq('active', true)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return data.id
}

export default function useGetAssetIdByName(name: string | undefined) {
  return useQuery({
    queryKey: ['useGetAssetIdByName', name],
    queryFn: () => getAssetId(name || ''),
    staleTime: 0,
    enabled: !!name,
  })
}
